<template>
  <multiselect
    :hide-selected="hideSelected"
    :value="value"
    :block-keys="keysToBlock"
    :class="hideExtraOptionsClass"
    :internalSearch="withInternalSearch"
    v-bind="multiselectBinds"
    v-on="proxyEvents"
    @input="$emit('input', $event)"
    @search-change="handleUpdateSearch"
  >
    <li
      v-if="hasAllSelected"
      slot="beforeList"
    >
      <span class="multiselect__option ensure-show">{{ emptyMessageResult }}</span>
    </li>
    <span slot="noOptions">
      {{ emptyMessageResult }}
    </span>
    <span slot="noResult">
      {{ emptyMessageResult }}
    </span>
    <template slot="tag" slot-scope="data">
      <span
        v-if="isTagWithNoRemove(data)"
        class="multiselect__no-remove-tag">
          {{ removeExtraWhiteSpace(data.option.name) }}
      </span>
      <span
        v-else
        class="multiselect__tag"
        :title="removeExtraWhiteSpace(data.option.name)"
      >
        <span>{{ removeExtraWhiteSpace(data.option.name) }}</span>
        <i
          class="multiselect__tag-icon"
          aria-hidden="true"
          tabindex="1"
          @click="data.remove(data.option)"
        ></i>
      </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import MultipleHelper from './builder';

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    withInternalSearch: {
      type: Boolean,
      default: true,
    },
    hideSelected: {
      type: Boolean,
      default: true,
    },
    emptyMessage: {
      type: String,
      required: false,
    },
    isTagWithNoRemove: {
      type: Function,
      default: () => false,
    },
    proxyBinds: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    proxyEvents: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  components: {
    Multiselect,
  },
  methods: {
    handleUpdateSearch(event) {
      this.$emit('search-change', event.replace(/\s+/g, ' ').trim());
    },
    removeExtraWhiteSpace(value) {
      return value.replace(/\s+/g, ' ').trim();
    },
  },
  computed: {
    hideExtraOptionsClass() {
      return this.hasAllSelected ? 'hide-option-classes' : '';
    },
    hasAllSelected() {
      return (this.value || []).length === (this.multiselectBinds?.options || []).length;
    },
    keysToBlock() {
      if (!this.value) return [];
      const lastTag = this.value[this.value.length - 1];
      return this.isTagWithNoRemove(lastTag) ? ['Delete'] : [];
    },
    emptyMessageResult() {
      return this.emptyMessage || this.$t('general.empty-list');
    },
    multiselectBinds() {
      return MultipleHelper(this, this.proxyBinds);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.ensure-show
  display: inline-block !important

.hide-option-classes
  ::v-deep
    .multiselect__option
      display: none

.multiselect__no-remove-tag
  margin: 3px 10px 0 0
  padding: 1px 10px
  color: $font-color-primary
  background: #e8e8e8
  border-radius: 24px

::v-deep
  @import "src/styles/vendor/vue-multiselect"

::v-deep .multiselect
  &__tags-wrap
    width: 100%
    display: inline-block
    padding: 0 0 5px
    max-height: 200px
    min-height: 30px
    overflow-y: auto
    scrollbar-width: thin
    // firefox
    &::-webkit-scrollbar-track
      border: none
      background-color: var(--color-breadcrumb-background)

    &::-webkit-scrollbar
      width: 7px

    &::-webkit-scrollbar-thumb
      background-color: $color-border-gray

  &__tags
    display: flex
    align-items: center
    flex-wrap: wrap

.multiselect--disabled
  background: inherit

  ::v-deep .multiselect__placeholder
    color: var(--font-color-quaternary)
</style>
